/* @flow */
import * as React from 'react';

import Image from 'components/Image.jsx';
import ListActions from 'components/ListActions';
import type {
  ListActionsFilterState,
  ListActionsCheckboxFilterState,
  ListActionsRadioFilterState,
  ListActionsSelectFilterState,
} from '../ListActions/ListActions.jsx';
import MediaObject from 'components/MediaObject.jsx';
import Row from 'components/Row.jsx';
import TextWithIcon from 'components/TextWithIcon.jsx';
import View from 'components/View.jsx';
import Views from 'components/Views.jsx';
import SettingsStore from 'stores/SettingsStore';

import PeopleListSidebar from './PeopleListSidebar.jsx';
import type { PeopleListSidebarType } from './PeopleListSidebar.jsx';
import PeopleListTable from './PeopleListTable.jsx';
import adminAvatarImage from './images/roles/admin.svg';
import noRoleAvatarImage from './images/roles/no-role.svg';
import parentAvatarImage from './images/roles/parent.svg';
import studentAvatarImage from './images/roles/student.svg';
import teacherAvatarImage from './images/roles/teacher.svg';
import './styles/PeopleList.scss';

function PeopleListRosterLabel(props) {
  return <TextWithIcon {...props} align="left" append gutter="xxsmall" iconSize="large" inline />;
}

type Props = {
  entityType: string,
  entityUuid: string,
};

export type PeopleListFilterState = {
  source?: ListActionsCheckboxFilterState,
  role?: ListActionsRadioFilterState,
  grade?: ListActionsSelectFilterState,
};

type State = {
  activeSidebar: PeopleListSidebarType,
  filters: PeopleListFilterState,
};

export default class PeopleList extends React.Component<Props, State> {
  state: State = {
    activeSidebar: 'workflows',
    filters: {
      role: 'teacher',
    },
  };

  handleFiltersChange = (activeFilters: ListActionsFilterState) => {
    this.setState({ filters: (activeFilters: any) });
  };

  handleQueryChange = (query: String) => {
    console.log('query', query);
    // this.setState({ query });
  };

  render() {
    const { activeSidebar, filters } = this.state;
    const { entityType, entityUuid } = this.props;

    const grades = SettingsStore.getSetting('grades').map(item => item.name);

    const roles = [
      {
        avatar: studentAvatarImage,
        count: '1,217',
        label: 'Students',
        value: 'student',
      },
      {
        avatar: parentAvatarImage,
        count: '2,457',
        label: 'Parents',
        value: 'parent',
      },
      {
        avatar: teacherAvatarImage,
        count: '114',
        label: 'Teachers',
        value: 'teacher',
      },
      {
        avatar: adminAvatarImage,
        count: '6',
        label: 'Admins',
        value: 'admin',
      },
      {
        avatar: noRoleAvatarImage,
        count: '17',
        label: 'No role',
        value: 'unknown',
      },
    ];

    const rolesWithDisplay = roles.map(item => ({
      ...item,
      display: (
        <MediaObject center gutter="xsmall" inline className="PeopleList-actions-label">
          <Image src={item.avatar} />
          <div>
            {item.label} ({item.count})
          </div>
        </MediaObject>
      ),
      value: item.value,
    }));

    const rosteredLabel = (
      <PeopleListRosterLabel
        icon="link-linked"
        iconColor="shamrock"
        className="PeopleList-actions-label">
        Rostered
      </PeopleListRosterLabel>
    );

    const notRosteredLabel = (
      <PeopleListRosterLabel
        icon="link-unlinked"
        iconColor="koala"
        className="PeopleList-actions-label">
        Not rostered
      </PeopleListRosterLabel>
    );

    const roleDisplay = role => {
      const matchingRole = rolesWithDisplay.find(item => item.value === role);
      if (matchingRole) {
        return matchingRole.display || matchingRole.label;
      } else {
        return null;
      }
    };

    return (
      <Views className="PeopleList">
        <View className="PeopleList-table" gutter="small" scroll>
          <Row>
            <ListActions
              filterButtonFace={filters['role'] && roleDisplay(filters['role'])}
              initialActiveFilters={((filters: any): ListActionsFilterState)}
              primaryFilters={[
                {
                  inputProps: {
                    nonTextLabel: true,
                  },
                  name: 'role',
                  options: rolesWithDisplay,
                  title: 'Role',
                  type: 'radio',
                },
              ]}
              secondaryFilters={[
                {
                  name: 'source',
                  options: new Map([['rostered', rosteredLabel], ['unrostered', notRosteredLabel]]),
                  title: 'Source',
                  type: 'checkbox',
                },
                {
                  inputProps: {
                    items: grades,
                    placeholder: '––',
                    className: 'PeopleList-grade',
                  },
                  name: 'grade',
                  title: 'Grade',
                  type: 'select',
                },
              ]}
              onFilterChange={this.handleFiltersChange}
              onQueryChange={this.handleQueryChange}
            />
          </Row>
          <PeopleListTable entityType={entityType} entityUuid={entityUuid} filters={filters} />
        </View>
        <View className="PeopleList-sidebar" gutter="small" scroll>
          <PeopleListSidebar activeSidebar={activeSidebar} />
        </View>
      </Views>
    );
  }
}
